import { render, staticRenderFns } from "./ModalCriarParametrosAplicacao.vue?vue&type=template&id=46ea21b0&scoped=true"
import script from "./ModalCriarParametrosAplicacao.vue?vue&type=script&lang=ts"
export * from "./ModalCriarParametrosAplicacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalCriarParametrosAplicacao.vue?vue&type=style&index=0&id=46ea21b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ea21b0",
  null
  
)

export default component.exports